import type { FaireProductEntity } from "../../entity_types/product";

export const p_x9u88cjqj5: FaireProductEntity = {
  token: "p_x9u88cjqj5",
  type: "product",
  name: "Pistachio Macaron Truffle",
  brandToken: "b_4tkquuuvuh",
  brandName: "The Chocolate Shoppe",
  imageUrl: "https://cdn.faire.com/fastly/3aaeb31a231137304de4e25442bf04d66a5c0e66beb4f5f02eab7e72b89a56b8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85f1045791ef557f2c88fdc729b14615a39da571742107b7da91d2ca77d7d9e1.png"
  ],
  priceDollars: 2.08,
  description: "A Belgian chocolate truffle crafted in the shape of a macaron — a silky, layered confection inspired by the classic French pastry.\n\nEach piece is formed with crisp white-chocolate discs enclosing a smooth pistachio ganache center, finished with a sprinkling of real pistachio pieces for texture and authenticity.\n\nThe flavor is light and nutty, blending creamy sweetness with the delicate richness of real roasted pistachio.\n\nOur Pistachio Macaron Truffle is elegant, shelf-stable, and ready for retail — ideal for cafés, gift shops, and gourmet markets seeking a refined, naturally green confection that ships beautifully and sells fast. (This is NOT a macaron cookie; this is two solid pieces of white chocolate with a chocolate cream ganache filling made to look like a macaron.)\n\nAvailable in a bulk tray of 28 pieces; perfect for presenting in your candy display case, a domed platter, or for packaging in your own boxes.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:41.195Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
